import { rcaPartnerIconSrc } from "../data/rcaPartnerIcons";

/** Logo partener RCA ( Claims / Why us ). */
export default function InsurerPartnerLogo({ url }) {
  const path = rcaPartnerIconSrc(url);
  if (!path) return null;

  const src = `${process.env.PUBLIC_URL ?? ""}${path}`;

  /*
   * Slot fix 108×32; imagine poziționată inset-0 astfel încât box-ul de randare are dimensiuni concrete.
   * object-contine scară uniformă (nu întinde SVG-uri late sau înalte).
   */
  return (
    <span className="relative block h-8 w-[108px] shrink-0 overflow-hidden leading-none">
      <img
        src={src}
        alt=""
        aria-hidden
        loading="lazy"
        decoding="async"
        className="pointer-events-none absolute inset-0 box-border h-full w-full object-contain object-center select-none"
      />
    </span>
  );
}
